var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoChevrondown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "7px",
    viewBox: "0 0 10 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VD",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "My-Rides",
    transform: "translate(-1399.000000, -636.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-53",
    transform: "translate(200.000000, 355.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-50",
    transform: "translate(0.000000, 253.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(1058.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico_chevrondown",
    transform: "translate(136.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#191919",
    fillRule: "nonzero",
    points: "13.7774111 7.22741127 14.9559224 8.4059226 10 13.361845 5.04407763 8.4059226 6.22258895 7.22741127 10 11.0048224"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoChevrondown);
export default __webpack_public_path__ + "static/media/ico_chevrondown.70d3f1765298df5047e499406fb29cc3.svg";
export { ForwardRef as ReactComponent };